import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { useGuideTour } from '../provider/guideTourContext'
import { matchGuideTourRoute } from './utils'

/** Navigates to the saved route and starts a tour launched from notifications. */
export const GuideTourPendingLaunchNavigator = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const {
    pendingGuideTourLaunch,
    clearPendingGuideTourLaunch,
    startWhenReady,
  } = useGuideTour()

  useEffect(() => {
    if (!pendingGuideTourLaunch) {
      return undefined
    }

    if (!matchGuideTourRoute(pendingGuideTourLaunch.targetRoute, pathname)) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- react-router navigate in effect
      navigate(pendingGuideTourLaunch.targetRoute)
      return undefined
    }

    startWhenReady(pendingGuideTourLaunch.tourId, {
      stepIndex: pendingGuideTourLaunch.stepIndex,
      viewedStepCount: pendingGuideTourLaunch.viewedStepCount,
      resume: pendingGuideTourLaunch.resume,
    })
    clearPendingGuideTourLaunch()

    return undefined
  }, [
    clearPendingGuideTourLaunch,
    navigate,
    pathname,
    pendingGuideTourLaunch,
    startWhenReady,
  ])

  return null
}
